module.exports = __webpack_public_path__ + "assets/img/small_rocket_logo.3352c3d2.png";